import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _interopRequireWildcard from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Fuse from 'fuse.js';
import { mapState } from 'vuex';
import mixin from '../mixin/menu';
export default {
  mixins: [mixin],
  components: {
    'd2-panel-search-item': function d2PanelSearchItem() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('./components/panel-search-item/index.vue'));
      });
    }
  },
  data: function data() {
    return {
      searchText: '',
      results: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/search', ['hotkey', 'pool'])), {}, {
    // 这份数据是展示在搜索面板下面的
    resultsList: function resultsList() {
      return this.results.length === 0 && this.searchText === '' ? this.pool.map(function (e) {
        return _objectSpread({
          value: e.fullTitle
        }, e);
      }) : this.results;
    },
    // 根据 pool 更新 fuse 实例
    fuse: function fuse() {
      return new Fuse(this.pool, {
        shouldSort: true,
        tokenize: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['fullTitle', 'path']
      });
    }
  }),
  methods: {
    /**
     * @description 过滤选项 这个方法在每次输入框的值发生变化时会触发
     */
    querySearch: function querySearch(queryString, callback) {
      var results = this.fuse.search(queryString).map(function (e) {
        return e.item;
      });
      this.results = results;
      callback(results);
    },

    /**
     * @description 聚焦输入框
     */
    focus: function focus() {
      var _this = this;

      this.input = '';
      setTimeout(function () {
        if (_this.$refs.input) {
          _this.$refs.input.focus();
        } // 还原


        _this.searchText = '';
        _this.results = [];
      }, 500);
    },

    /**
     * @description 接收用户在列表中选择项目的事件
     */
    handleResultsGroupItemClick: function handleResultsGroupItemClick(path) {
      // 如果用户选择的就是当前页面 就直接关闭搜索面板
      if (path === this.$route.path) {
        this.handleEsc();
        return;
      } // 用户选择的是其它页面


      this.handleMenuSelect(path);
    },

    /**
     * @description 接收用户在下拉菜单中选中事件
     */
    handleSelect: function handleSelect(_ref) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var path;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _ref.path;

                if (!(path === _this2.$route.path)) {
                  _context.next = 4;
                  break;
                }

                _this2.handleEsc();

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return _this2.$nextTick();

              case 6:
                _this2.handleMenuSelect(path);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @augments 关闭输入框的下拉菜单
     */
    closeSuggestion: function closeSuggestion() {
      if (this.$refs.input.activated) {
        this.$refs.input.suggestions = [];
        this.$refs.input.activated = false;
      }
    },

    /**
     * @augments 接收用户点击空白区域的关闭
     */
    handlePanelClick: function handlePanelClick() {
      this.handleEsc();
    },

    /**
     * @augments 接收用户触发的关闭
     */
    handleEsc: function handleEsc() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.closeSuggestion();

                _context2.next = 3;
                return _this3.$nextTick();

              case 3:
                _this3.$emit('close');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};